"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalDefaultValues = exports.CloseSides = void 0;
var CloseSides = {
  Leading: 'Leading',
  Trailing: 'Trailing'
};
exports.CloseSides = CloseSides;
var modalDefaultValues = {
  closeButtonSide: CloseSides.Leading,
  hasDynamicPadding: false,
  titleSize: 32,
  useHairlineDividers: false
};
exports.modalDefaultValues = modalDefaultValues;